import { geoProvider, type LatLng, type LineString, type PlaceSuggestion } from './geo';
import { mapboxApiKey } from './environment';

// В этом файле функции для работы с геоданными.
// Сетевые запросы выполняет гео-провайдер (см. ./geo), выбранный через VITE_MAP_PROVIDER.

export type RouteWaypoint = {
  latitude: number | string | null;
  longitude: number | string | null;
  departureDateTime?: string;
  arrivedDateTime?: string;
};

export type DirectionsResult = {
  distance: number;
  distanceAtStart: number;
  distanceAtEnd: number;
  geoJSON: LineString;
};

/**
 * тайлы(подложка) карты используется мапбоксовская,
 * потому что мне она кажеся симпатичнее чам OSM
 * АПИ кей может протухнуть когда-нибудь
 */
export const MAPBOX_API_KEY = mapboxApiKey;

/*
  Принимает широту и долготу, возвращает адрес строкой
 */
export const geocode = (lat: number, lng: number): Promise<string> =>
  geoProvider.reverseGeocode(lat, lng);

// Сравнение как у lodash/orderBy: по возрастанию, пустые значения в конце
const compareOptional = (a?: string, b?: string): number => {
  if (a === b) return 0;
  if (a == null) return 1;
  if (b == null) return -1;
  return a < b ? -1 : 1;
};

// Строит маршрут по графу дорог
export const directions = async (waypoints: RouteWaypoint[]): Promise<DirectionsResult> => {
  if (waypoints.length < 2) {
    throw new Error('At least two wayoints required');
  }

  // нам важен порядок точек, чтобы построить правильные ребра графа
  const orderedWaypoints = [...waypoints].sort(
    (a, b) =>
      compareOptional(a.departureDateTime, b.departureDateTime) ||
      compareOptional(a.arrivedDateTime, b.arrivedDateTime)
  );

  const { legDistances, geoJSON } = await geoProvider.route(
    orderedWaypoints.map(({ latitude, longitude }) => ({
      lat: Number(latitude),
      lng: Number(longitude),
    }))
  );
  return {
    distance: legDistances.reduce((sum, distance) => sum + distance, 0),
    distanceAtStart: legDistances[0],
    distanceAtEnd: legDistances[legDistances.length - 1],
    geoJSON,
  };
};

export const searchPlaces = (query: string): Promise<PlaceSuggestion[]> =>
  geoProvider.searchPlaces(query);

export const resolvePlace = (place: PlaceSuggestion): Promise<LatLng> =>
  geoProvider.resolvePlace(place);

/**
 * Промисифицированная функция получения геолокации
 */
export const getCurrentPosition = async (): Promise<GeolocationPosition> =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  });
